

export const profileList = ["Efficiency", "Optimization", "Refactoring", "Architecture", "Integration"]